// constants

const FOUR_D_PLACE_BET_SET = "FOUR_D_PLACE_BET_SET";
const FOUR_D_PLACE_BET_REMOVE = "FOUR_D_PLACE_BET_REMOVE";
const FOUR_D_PLACE_BET_EMPTY = "FOUR_D_PLACE_BET_EMPTY";
const FOUR_D_PLACE_BET_SET_BOARD = "FOUR_D_PLACE_BET_SET_BOARD";
const FOUR_D_PLACE_BET_APPEND_BOARD = "FOUR_D_PLACE_BET_APPEND_BOARD";

// reducers

const initialState = {};

const FourDPlaceBet = (state = initialState, action) => {
  switch (action.type) {
    case FOUR_D_PLACE_BET_SET:
      return { ...action.payload };

    case FOUR_D_PLACE_BET_REMOVE:
      let board = { ...state.board };
      board.splice(action.payload, 1);
      return { ...state, board: board };

    case FOUR_D_PLACE_BET_EMPTY:
      return {};

    case FOUR_D_PLACE_BET_SET_BOARD:
      return {
        betType: "Ordinary",
        drawWeeks: [],
        board: [...action.payload],
        total: 0,
      };

    case FOUR_D_PLACE_BET_APPEND_BOARD:
      if (Object.entries(state).length > 0)
        return { ...state, board: [...state?.board, ...action.payload] };
      else
        return {
          betType: "Ordinary",
          drawWeeks: [],
          board: [...action.payload],
          total: 0,
        };
    default:
      return state;
  }
};

export default FourDPlaceBet;

// actions
export const fourDPlaceBetSet = (payloadObj) => {
  return {
    type: FOUR_D_PLACE_BET_SET,
    payload: payloadObj,
  };
};

export const fourDPlaceBetSetBoard = (payload) => {
  return {
    type: FOUR_D_PLACE_BET_SET_BOARD,
    payload: payload,
  };
};

export const fourDPlaceBetAppendBoard = (payload) => {
  return {
    type: FOUR_D_PLACE_BET_APPEND_BOARD,
    payload: payload,
  };
};

export const fourDPlaceBetRemove = (payloadId) => {
  return {
    type: FOUR_D_PLACE_BET_REMOVE,
    payload: payloadId,
  };
};

export const fourDPlaceBetEmpty = () => {
  return {
    type: FOUR_D_PLACE_BET_EMPTY,
  };
};
